import { AttributeFilters } from "@/models/attributeFilter";

export const MessageType = {
  USER: "user",
  ASSISTANT: "assistant",
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];

export const TMP_CONVERSATION_KEY = "__tmp__";

export class Message {
  constructor(
    public id: string,
    public type: MessageType,
    public content: string,
    public vocIds?: string[],
    public categories?: string[],
    public vocPeriodStart?: Date,
    public vocPeriodEnd?: Date,
    public attributeFilters?: AttributeFilters,
    public tagIds?: string[],
  ) {}
}

export class Conversation {
  constructor(
    public id: string,
    public name: string,
    public created_at: Date,
    public updated_at?: Date,
  ) {}
}
